import {RouteObject} from 'react-router-dom';
import FullLayout from '../../layout/wholesaler/fullLayout';
import ChatContainer from './chat/chatContainer';
import {ProtectedRoute} from 'modules/protectedRoute/market';
import BuyersPage from './buyers';
import AddAdsPage from './createAd/addAd';
import AccountPage from './account';

import AddsContainer from './adds';
import PurchaseContainer from './purchase/mainPurchase';
import PurchaseInfoContainer from './purchase/purchaseInfo';
import PurchaseRegistrationContainer from './purchase/purchaseRegistration';
import PurchaseProductsContainer from './purchase/purchaseProducts';
import PurchaseSubproductsContainer from './purchase/purchaseSubproducts';
import {PurchaseProvider} from 'context/purchaseContext';
import TypeAds from './createAd/typeAds';
import {WholesalerProvider} from 'context/wholesaler';
import Info from './createAd/form/info';
import QualityForm from './createAd/form/quality';
import OwnerForm from './createAd/form/owner';
import MyAdvertismentContainer from './myAdvertisment/myAdvertisment';
import SimpleDetailPage from './productDetail/simple';
import SaleDetailPage from './productDetail/sale';
import PrepaymentDetailPage from './productDetail/prepayment';
import AuctionDetailPage from './productDetail/auction';
import RolesPage from './account/roles';
import SupportPage from './account/support';
import QuestionsPage from './account/support/questions';
import AboutPage from './account/about';
import ShownAdsPage from './account/shownAds';
import MyAdvertismentDetailContainer from './myAdvertisment/myAdvertismentDetail';
import PurchaseEditContainer from './purchase/purchaseEdit';
import Guide from './createAd/guide';
import Profile from './profile';
import EditInfoForm from './createAd/editForm/information';
import EditQualityForm from './createAd/editForm/quality';
import EditOwnerForm from './createAd/editForm/owner';
import {Suspense, lazy} from 'react';
import Skeleton from 'components/skleton/home';
import HotActionAddsContainer from './hotAuctionAdds';
const Home = lazy(() => import('./home'));

export const WholesalerRoutes: RouteObject[] = [
  {
    path: 'wholesaler',
    element: (
      <ProtectedRoute>
        <PurchaseProvider>
          <WholesalerProvider>
            <FullLayout />
          </WholesalerProvider>
        </PurchaseProvider>
      </ProtectedRoute>
    ),
    errorElement: <>error page</>,
    children: [
      {
        index: true,
        path: 'home',
        element: (
          <Suspense fallback={<Skeleton />}>
            <Home />
          </Suspense>
        ),
      },
      {
        index: false,
        path: 'buyers',
        element: <BuyersPage />,
      },
      {
        index: false,
        path: 'add-ad',
        element: <AddAdsPage />,
      },
      {
        index: false,
        path: 'account',
        element: <AccountPage />,
      },
      {
        index: false,
        path: 'profile/edit',
        element: <Profile />,
      },
      {
        index: false,
        path: 'chats',
        element: <ChatContainer />,
      },
      {
        index: false,
        path: 'add-ad/type-ads',
        element: <TypeAds />,
      },
      {
        index: false,
        path: 'add-ad/info',
        element: <Info />,
      },
      {
        index: false,
        path: 'add-ad/quality',
        element: <QualityForm />,
      },
      {
        index: false,
        path: 'add-ad/owner',
        element: <OwnerForm />,
      },
      {
        index: false,
        path: 'add-ad/purchase',
        element: <PurchaseContainer />,
      },
      {
        index: false,
        path: 'add-ad/purchase/products/:cateId',
        element: <PurchaseProductsContainer />,
      },
      {
        index: false,
        path: 'add-ad/purchase/subproducts/:productId',
        element: <PurchaseSubproductsContainer />,
      },
      {
        index: false,
        path: 'add-ad/purchase/info/:purchaseId',
        element: <PurchaseInfoContainer />,
      },
      {
        index: false,
        path: 'add-ad/purchase/registration/:purchaseId',
        element: <PurchaseRegistrationContainer />,
      },
      {
        index: false,
        path: 'simple/:guid',
        element: <SimpleDetailPage />,
      },
      {
        index: false,
        path: 'sale/:guid',
        element: <SaleDetailPage />,
      },
      {
        index: false,
        path: 'prepayment/:guid',
        element: <PrepaymentDetailPage />,
      },
      {
        index: false,
        path: 'auction/:guid',
        element: <AuctionDetailPage />,
      },
      {
        index: false,
        path: 'account/roles',
        element: <RolesPage />,
      },
      {
        index: false,
        path: 'account/support',
        element: <SupportPage />,
      },
      {
        index: false,
        path: 'adds/:guid?',
        element: <AddsContainer />,
      },
      {
        index: false,
        path: 'adds/hot-auctions/:guid?',
        element: <HotActionAddsContainer />,
      },
      {
        index: false,
        path: 'account/support/questions',
        element: <QuestionsPage />,
      },
      {
        index: false,
        path: 'account/about',
        element: <AboutPage />,
      },
      {
        index: false,
        path: 'account/shown-ads',
        element: <ShownAdsPage />,
      },
      {
        index: false,

        path: 'my-advertisment',
        element: <MyAdvertismentContainer />,
      },
      {
        index: false,
        path: 'my-advertisment/detail/:guid',
        element: <MyAdvertismentDetailContainer />,
      },
      {
        index: false,
        path: 'add-ad/purchase/edit/:guid',
        element: <PurchaseEditContainer />,
      },
      {
        index: false,
        path: 'guide-to-add-product',
        element: <Guide />,
      },
      {
        index: false,
        path: 'edit/info/:guid',
        element: <EditInfoForm />,
      },
      {
        index: false,
        path: 'edit/quality/:guid',
        element: <EditQualityForm />,
      },
      {
        index: false,
        path: 'edit/owner/:guid',
        element: <EditOwnerForm />,
      },
    ],
  },
];
